import topic from '../topic'
export const mconAPI = {
    getMcons: topic.mconTopic + '/get_mcons',
    getMconById: topic.mconTopic + '/get_mcon_by_id',
    addMcon: topic.mconTopic + '/add_mcon',
    editMcon: topic.mconTopic + '/edit_mcon',
    deleteMconByIds: topic.mconTopic + '/delete_mcon_by_ids'
}